<template>
  <div>
    <div class="talent-pool-body ml-5 mt-3">
      <h5 class="common-pg-heading">New Hire Details</h5>
    </div>

    <div class="common-border ml-5"></div>
    <div class="mt-4 maincontainer">
      <b-row>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="First name *"
            label-for="input-1"
          >
            <b-form-input
              class="input-text"
              id="input-1"
              type="text"
              placeholder="Enter First Name"
              v-model="firstname"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Middle name *"
            label-for="input-1"
          >
            <b-form-input
              class="input-text"
              id="input-1"
              type="text"
              placeholder="Enter Middle Name"
              v-model="middlename"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Last name *"
            label-for="input-1"
          >
            <b-form-input
              class="input-text"
              id="input-1"
              type="text"
              placeholder="Enter last Name"
              v-model="lastname"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Email address:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="email"
              type="email"
              placeholder="Enter email"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Contact Number *"
            label-for="input-1"
          >
            <b-form-input
              class="input-text"
              id="input-1"
              type="text"
              placeholder="Enter Contact Name"
              v-model="contactno"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Telephone Number *"
            label-for="input-1"
          >
            <b-form-input
              class="input-text"
              id="input-1"
              type="text"
              placeholder="Enter Telephone Number"
              v-model="teleno"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Fax Number *"
            label-for="input-1"
          >
            <b-form-input
              class="input-text"
              id="input-1"
              type="text"
              placeholder="Enter Fax Number"
              v-model="faxno"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Date of Birth *"
            label-for="input-1"
          >
            <b-form-datepicker
              id="example-datepicker"
              v-model="dob"
              class="mb-2"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Date of Joining *"
            label-for="input-1"
          >
            <b-form-datepicker
              id="example-datepicker"
              v-model="doj"
              class="mb-2"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Offered CTC *"
            label-for="input-1"
          >
            <b-form-input
              class="input-text"
              id="input-1"
              type="text"
              placeholder="Enter CTC in LPA"
              v-model="offeredctc"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Source"
            label-for="input-1"
          >
            <b-form-select
              placeholder="Select one option"
              :options="sourceoptions"
              v-model="sourcetype"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Source Category"
            label-for="input-1"
          >
            <b-form-select
              placeholder="Select one option"
              :options="sourcecategoryoptions"
              v-model="sourcecategory"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Portfolio Platform"
            label-for="input-1"
          >
            <b-form-select
              placeholder="Select one option"
              :options="portfolio_options"
              v-model="portfolio"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Candidate Portfolio Platform *"
            label-for="input-1"
          >
            <b-form-input
              class="input-text"
              id="input-1"
              type="text"
              placeholder="Enter here"
              v-model="portfolioinput"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Employer Details *"
            label-for="input-1"
          >
            <b-form-input
              class="input-text"
              id="input-1"
              type="text"
              placeholder="Enter here"
              v-model="empdetails"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Department *"
            label-for="input-1"
          >
            <b-form-input
              class="input-text"
              id="input-1"
              type="text"
              placeholder="Enter here"
              v-model="dept"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            class="subtitles1"
            id="input-group-1"
            label="Designation *"
            label-for="input-1"
          >
            <b-form-input
              class="input-text"
              id="input-1"
              type="text"
              placeholder="Enter here"
              v-model="designation"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col style="display: flex; justify-content: flex-end">
          <b-button variant="outline" class="attachdocs" @click="attach()">
            Attach Documents
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "HireEmployee",
  data() {
    return {
      firstname: "",
      middlename: "",
      lastname: "",
      email: "",
      contactno: "",
      teleno: "",
      faxno: "",
      dob: "",
      doj: "",
      offeredctc: "",
      sourceoptions: [
        {
          value: null,
          text: "Source",
          disabled: true,
        },
        {
          value: "naukri",
          text: "Naukri",
        },
        {
          value: "monster",
          text: "Monster",
        },
        {
          value: "indeed",
          text: "Indeed",
        },
        {
          value: "linkedin",
          text: "Linked In",
        },
      ],
      sourcetype: null,
      sourcecategoryoptions: [
        {
          value: null,
          text: "Source Category",
          disabled: true,
        },
        {
          value: "sc1",
          text: "Source Category 1",
        },
        {
          value: "sc2",
          text: "Source Category 2",
        },
        {
          value: "sc3",
          text: "Source Category 3",
        },
        {
          value: "sc4",
          text: "Source Category 4",
        },
      ],
      sourcecategory: null,
      portfolio_options: [
        {
          value: null,
          text: "Portfolio Platforms",
          disabled: true,
        },
        {
          value: "behance",
          text: "Behance",
        },
        {
          value: "blog",
          text: "Blog",
        },
        {
          value: "dribble",
          text: "Dribble",
        },
        {
          value: "gitlab",
          text: "GitLab",
        },
        {
          value: "medium",
          text: "Medium",
        },
      ],
      portfolio: null,
      portfolioinput: "",
      empdetails: "",
      designation: "",
      dept: "",
    };
  },
  methods: {
    attach() {
      this.$router.push({
        name: "AttachDocs",
      });
    },
  },
};
</script>

<style scoped>
.attachdocs {
  background: #333456 !important;
  color: #ffffff !important;
  display: flex;
  cursor: pointer;
  margin-top: 1em;
}
.maincontainer {
  width: 90vw;
  margin-left: 2.5em;
  padding: 25px;
  box-shadow: -5px 5px 15px #c7c7c7;
  height: 75vh;
  overflow-y: auto;
}
</style>
